export default __webpack_public_path__ + "static/media/light-logo.bd23c613.png";